<div class="image-editor">
  
  <!-- TIÊU ĐỀ MỞ RỘNG -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>

  <!-- DANH SÁCH CÁC MENU -->
  <div *ngIf="!isViewAll">
    <app-position-out-config   [elementChoosing]="objectChoosing" [device]="device"
      [id_parent_choose]="objectChoosing.id_block? objectChoosing.id_block: objectChoosing.id_object"></app-position-out-config>

    <app-width-height-config    [device]="device"   [elementChoosing]="objectChoosing" [width]="class['image-detail']['width']" [height]="class['image-detail']['height']"
      (changeWidthHeight)="changeWidthHeight($event)"></app-width-height-config>
    <!-- NHÓM ẢNH ĐỂ NGƯỜI DÙNG CHỌN -->
    <div class="editor-content">
      <!-- Grid layout -->
      <div class="block-grid" style="padding: 5px; height: 200px">
        <div (click)="onClickObject('object', $event)"
          class="object active-select w-100 h-100" 
          [ngClass]="config['classes_image']['grid_class']"
          style="outline: 2px dashed green; padding: 16px" 
          [ngStyle]="{
            'justify-content': config['classes_image']['grid_class'] == 'image-detail-grid-3' ? 'space-around' : 'flex-start'
          }">
          <!-- Ảnh chính -->
          <div class="main-image" style="outline: 2px dashed green" (click)="onClickObject('main-image', $event)">
            <!-- Carousel hình ảnh sản phẩm -->
            <div [id]="carouselID"
              class="carousel-layer-image w-100" 
              [ngClass]="config['main_image']['effect_carousel_class']">
              <div class="carousel-layer" *ngIf="config['main_image']['is_active_carousel']"
                (mousedown)="onMouseDown(carouselID, $event)" 
                (mouseup)="onMouseUp(carouselID, $event)"
                (mouseenter)="onMouseEnter(carouselID, $event)" 
                (mousemove)="onMouseMove(carouselID, $event)">
              </div>
              <!-- carousel inner -->
              <div class="carousel-layer-image-inner" 
                id="carousel-inner" 
                [ngStyle]="{
                  transition: config['main_image']['effect_carousel_duration'] + 's'
                }">
                <div class="item" 
                  *ngFor="let item of arrayImage; let i = index"
                  [ngClass]="{ show: counterIndex === i }">
                  {{ item }}
                </div>
              </div>
              <!-- Arrows control -->
              <div class="prev-btn" 
                *ngIf="config['main_image']['is_active_carousel']" 
                [ngStyle]="{
                  opacity: counterIndex === 0 && config['main_image']['effect_carousel_class'] == 'carousel-transition' ? '0.4' : '1'
                }">
                <i (click)="onImagePrev(carouselID)"
                  [class]="config['main_image']['arrow_left_icon']" 
                  [ngClass]="{
                    'arrow-hover': config['main_image']['is_active_arrow_action']
                  }" 
                  [ngStyle]="{
                    color: class['main-image__icon']['color'],
                    'font-size': class['main-image__icon']['font-size'],
                    'background-color': class['main-image__icon']['background-color'],
                    opacity: class['main-image__icon']['opacity']
                  }"
                  [style.--image-detail-variable-arrow-background-color]="config['main_image']['arrow_action_hover_background']" 
                  [style.--image-detail-variable-arrow-color]="config['main_image']['arrow_action_hover_color']" 
                  [style.--image-detail-variable-arrow-duration]="config['main_image']['arrow_action_hover_duration'] + 's'" 
                  [style.--image-detail-variable-arrow-opacity]="config['main_image']['arrow_action_hover_color_opacity']">
                </i>
              </div>
              <div class="next-btn" 
                *ngIf="config['main_image']['is_active_carousel']" 
                [ngStyle]="{
                  opacity: counterIndex >= arrayImage.length - 1 && config['main_image']['effect_carousel_class'] == 'carousel-transition'
                    ? '0.4'
                    : '1'
                }">
                <i (click)="onImageNext(carouselID, $event)"
                  [class]="config['main_image']['arrow_right_icon']" 
                  [ngClass]="{
                    'arrow-hover': config['main_image']['is_active_arrow_action']
                  }" 
                  [ngStyle]="{
                    color: class['main-image__icon']['color'],
                    'font-size': class['main-image__icon']['font-size'],
                    'background-color': class['main-image__icon']['background-color'],
                    opacity: class['main-image__icon']['opacity']
                  }"
                  [style.--image-detail-variable-arrow-background-color]="config['main_image']['arrow_action_hover_background']" 
                  [style.--image-detail-variable-arrow-color]="config['main_image']['arrow_action_hover_color']" 
                  [style.--image-detail-variable-arrow-duration]="config['main_image']['arrow_action_hover_duration'] + 's'" 
                  [style.--image-detail-variable-arrow-opacity]="config['main_image']['arrow_action_hover_color_opacity']">
                </i>
              </div>
            </div>
          </div>
          <!-- Nhóm ảnh nhỏ -->
          <div *ngIf="config['classes_image']['grid_class'] != 'image-detail-grid-3'" 
            class="orther-image"
            style="outline: 2px dashed green" 
            (click)="onClickObject('side-image', $event)" 
            [ngStyle]="{
              'justify-content': config['side_image']['justify']
            }">
            <div (click)="gotoImageIndex(carouselID, i)"
              class="sm-image square" 
              *ngFor="let item of arrayImage; let i = index" 
              [ngClass]="{
                actived: counterIndex === i && config['main_image']['is_active_carousel']
              }">
              <p alt="" style="
                  width: 100%;
                  height: 100%;
                  position: absolute;
                  top: 0;
                  left: 0;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                ">
                {{item}}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- PHẦN MENU CẤU HÌNH -->
    <div class="editor-content scroll-style">
      <ul nz-menu nzMode="inline">
        <ng-container *ngIf="gridObjSelected === 'object'">
          <!-- CẤU HÌNH BỐ CỤC -->
          <li nz-submenu [nzTitle]="'vi_tri' | translate" nzIcon="profile">
            <div class="d-flex justify-content-between align-items-center">
              <span>{{ 'dang_xem_danh_sach' | translate }}</span>
              <nz-switch [ngModel]="config['image-detail__images']['is_list_view']"
              (ngModelChange)="handleListView($event)"></nz-switch>
            </div>
            <ng-container *ngIf="!config['image-detail__images']['is_list_view']">
              <p class="my-3">{{'bo_cuc' | translate}}</p>
              <nz-radio-group [(ngModel)]="config['classes_image']['grid_class']" 
                (ngModelChange)="updateConfig()"
                class="radio-group">
                <label nz-radio-button nzValue="image-detail-grid-0" class="radio-button">{{'kieu' | translate}} 1</label>
                <label nz-radio-button nzValue="image-detail-grid-1" class="radio-button">{{'kieu' | translate}} 2</label>
                <label nz-radio-button nzValue="image-detail-grid-2" class="radio-button">{{'kieu' | translate}} 3</label>
                <label nz-radio-button nzValue="image-detail-grid-3" class="radio-button">{{'kieu' | translate}} 4</label>
              </nz-radio-group>
            </ng-container>
            <ng-container *ngIf="config['image-detail__images']['is_list_view']">
              <div class="config-name">
                <p>{{'so_cot' | translate}}</p>
                <nz-input-number [nzMin]="1" [nzStep]="1"
                  [(ngModel)]="config['image-detail__images']['cols']" 
                  (nzBlur)="updateRowCol()">
                </nz-input-number>
              </div>
              <div class="config-name">
                <p>{{'khoang_cach' | translate}}</p>
                <nz-input-number [nzMin]="1" [nzStep]="1"
                  [ngModel]="class['image-detail__images']['gap'] | vhnumber" 
                  (ngModelChange)="class['image-detail__images']['gap'] = $event + 'px';"
                  (nzBlur)="updateRowCol()">
                </nz-input-number>
              </div>
            </ng-container>
          </li>
        </ng-container>
        <!-- TIÊU ĐỀ HIỂN THỊ ẢNH CHÍNH / NHÓM ẢNH NHỎ ĐƯỢC CHỌN -->
        <div *ngIf="gridObjSelected == 'main-image' || gridObjSelected == 'side-image'" class="mt-4 mb-3">
          <b style="font-size: 1.125rem">{{(gridObjSelected == 'main-image' ? 'anh_chinh' : 'nhom_anh_nho') | translate}}</b>
        </div>
        <!-- CẤU HÌNH ẢNH CHÍNH -->
        <li nz-submenu [nzTitle]="'thao_tac_voi_anh_chinh' | translate" nzIcon="profile" *ngIf="gridObjSelected == 'main-image'">
          <ul nz-menu nzMode="inline">
            <!-- CÀI ĐẶT THÀNH PHẦN -->
            <li nz-submenu [nzTitle]="'cai_dat_thanh_phan' | translate" [(nzOpen)]="openMap.menu15" (nzOpenChange)="openHandler('menu15')">
              <!-- Phóng to -->
              <div class="editor-field">
                <div class="config-name mt-0">
                  <p>{{'phong_to' | translate}}</p>
                  <nz-switch [(ngModel)]="config['main_image']['is_active_image_zoom']" (ngModelChange)="onZoomSwitch()"></nz-switch>
                </div>
              </div>
              <!-- Hiệu ứng chuyển ảnh -->
              <div class="editor-field">
                <!-- Hiệu ứng chuyển ảnh -->
                <div class="config-name mt-0">
                  <p>{{'hieu_ung_chuyen_anh' | translate}}</p>
                  <nz-switch [(ngModel)]="config['main_image']['is_active_carousel']" (ngModelChange)="updateConfig()"></nz-switch>
                </div>
                <!-- Carousel -->
                <div *ngIf="config['main_image']['is_active_carousel']" class="mt-3">
                  <!-- Carousel -->
                  <div class="field-row">
                    <div class="carousel-slide" id="effect-carousel">
                      <div class="carousel-next" (click)="onNext('effect-carousel', 1)">
                        <i class="bi bi-chevron-compact-right"></i>
                      </div>
                      <div class="carousel-slide-inner">
                        <div class="item effect" [ngClass]="{
                              actived:
                                config['main_image'][
                                  'effect_carousel_class'
                                ] === 'carousel-default'
                            }" (click)="onSelectEffect('default')">
                          <img src="/assets/root/images/system/icons/effect_slide_default.svg" alt="" />
                        </div>
                        <div class="item effect" [ngClass]="{
                              actived:
                                config['main_image'][
                                  'effect_carousel_class'
                                ] === 'carousel-fadeout'
                            }" (click)="onSelectEffect('fade')">
                          <img src="/assets/root/images/system/icons/effect_slide_fadeout.svg" alt="" />
                        </div>
                        <div class="item effect" [ngClass]="{
                              actived:
                                config['main_image'][
                                  'effect_carousel_class'
                                ] === 'carousel-transition'
                            }" (click)="onSelectEffect('transition')">
                          <img src="/assets/root/images/system/icons/effect_slide_transition.svg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Tự động chuyển/ Thời gian chờ / Thời gian chuyển hiệu ứng -->
                  <div class="field-row mt-4">
                    <!-- Tự động chuyển -->
                    <div class="config-name">
                      <p>{{'tu_dong_chuyen' | translate}}</p>
                      <nz-switch [(ngModel)]="config['main_image']['is_autoplay']"
                        (ngModelChange)="updateConfig()"></nz-switch>
                    </div>
                    <!-- Thời gian chờ -->
                    <div *ngIf="config['main_image']['is_autoplay']" class="mb-4">
                      <div class="config-name">
                        <p>{{'thoi_gian_cho' | translate}} (s)</p>
                        <nz-input-number [nzMin]="0" [nzMax]="5" [nzStep]="0.1"
                          [(ngModel)]="config['main_image']['time_auto_play']" 
                          (nzBlur)="updateConfig()">
                        </nz-input-number>
                      </div>
                      <nz-slider [nzMin]="0" [nzMax]="5" [nzStep]="0.1"
                        [(ngModel)]="config['main_image']['time_auto_play']" 
                        (nzOnAfterChange)="updateConfig()">
                      </nz-slider>
                    </div>
                    <!-- Thời gian chuyển hiệu ứng -->
                    <div class="config-name">
                      <p>{{'thoi_gian_chuyen_hieu_ung' | translate}}</p>
                      <nz-input-number [nzMin]="0" [nzMax]="5" [nzStep]="0.1"
                        [(ngModel)]="config['main_image']['effect_carousel_duration']"
                        (nzBlur)="updateConfig()">
                      </nz-input-number>
                    </div>
                    <nz-slider [nzMin]="0" [nzMax]="5" [nzStep]="0.1"
                      [(ngModel)]="config['main_image']['effect_carousel_duration']"
                      (ngModelChange)="config['main_image']['effect_carousel_duration'] = $event"
                      (nzOnAfterChange)="updateConfig()">
                    </nz-slider>
                  </div>
                  <!-- Cấu hình icon -->
                  <ul class="mt-4">
                    <!-- Cấu hình biểu tượng chuyển ảnh -->
                    <li nz-submenu [nzTitle]="'cau_hinh_bieu_tuong_chuyen_anh'| translate" [(nzOpen)]="openMapSub.submenu1" (nzOpenChange)="openHandler('submenu1', true)">
                      <!-- Cấu hình icon -->
                      <div class="field-row mb-3">
                        <div *ngIf="config['main_image']['is_active_carousel']" class="mt-3">
                          <!-- Hiện icon khi di chuột -->
                          <div class="field-row mb-3">
                            <div class="config-name mt-0">
                              <p>{{'hien_icon_khi_di_chuot' | translate}}</p>
                              <nz-switch [(ngModel)]="config['main_image']['is_hide_arrow']" (ngModelChange)="updateConfig()"></nz-switch>
                            </div>
                          </div>
                          <!-- Kiểu icon -->
                          <div class="field-row my-3">
                            <div class="config-name mt-0">
                              <p>{{'kieu' | translate}}</p>
                              <!-- Danh sách icon để chọn -->
                              <div style="width: 40%">
                                <!-- Nút chọn icon -->
                                <button nz-button nz-dropdown [nzDropdownMenu]="menu" style="width: 100%; padding: 2px;" [nzPlacement]="positionSelect">
                                  <div style="font-size: 17px; display: flex; justify-content: space-around;">
                                    <i [class]="config['main_image']['arrow_left_icon']"></i>
                                    <i [class]="config['main_image']['arrow_right_icon']"></i>
                                  </div>
                                </button>
                                <!-- Danh sách icon -->
                                <nz-dropdown-menu #menu="nzDropdownMenu">
                                  <ul nz-menu>
                                    <li nz-menu-item *ngFor="let item of bootstrapIconArrows"
                                      (click)="onChangeArrows(item)">
                                      <div style="font-size: 18px; display: flex; justify-content: space-around; padding: 10px 0px;">
                                        <i [class]="item.icon_left"></i>
                                        <i [class]="item.icon_right"></i>
                                      </div>
                                    </li>
                                  </ul>
                                </nz-dropdown-menu>
                              </div>
                            </div>
                          </div>
                          <!-- Kích thước icon -->
                          <div class="config-name my-3">
                            <p>{{'kich_thuoc' | translate}}</p>
                            <nz-input-number [nzMin]="1" [nzMax]="100" [nzStep]="1"
                              [ngModel]="class['main-image__icon']['font-size'] | vhnumber"
                              (ngModelChange)="class['main-image__icon']['font-size'] = $event +'px'"
                              (nzBlur)="updateClass()">
                            </nz-input-number>
                          </div>
                          <!-- Màu sắc icon -->
                          <div class="config-name">
                            <p>{{'mau_sac' | translate}}</p>
                            <input class="input-color" type="button"
                              [cpOKButton]="true" 
                              [style.background]="class['main-image__icon']['color']"
                              [(colorPicker)]="class['main-image__icon']['color']" 
                              (colorPickerClose)="updateClass()" />
                          </div>
                          <!-- Màu nền -->
                          <div class="config-name">
                            <p>{{'mau_nen' | translate}}</p>
                            <input class="input-color" type="button"
                              [cpOKButton]="true" 
                              [style.background]="class['main-image__icon']['background-color']"
                              [(colorPicker)]="class['main-image__icon']['background-color']"
                              (colorPickerClose)="updateClass()" />
                          </div>
                          <!-- Độ trong suốt -->
                          <div>
                            <div class="config-name">
                              <p>{{'do_trong_suot' | translate}}</p>
                              <nz-input-number [nzMin]="0" [nzMax]="1" [nzStep]="0.1"
                                [(ngModel)]="class['main-image__icon']['opacity']"
                                (nzBlur)="updateClass()">
                              </nz-input-number>
                            </div>
                            <nz-slider [nzMin]="0" [nzMax]="1" [nzStep]="0.1"
                              [(ngModel)]="class['main-image__icon']['opacity']"
                              (nzOnAfterChange)="updateClass()">
                            </nz-slider>
                          </div>
                          <!-- Nút mở rộng -->
                          <div class="config-name view-more-btn">
                            <p (click)="openViewAll(style_fields[2])">{{'mo_rong' | translate}} &#8594;</p>
                          </div>
                        </div>
                      </div>
                    </li>
                    <!--Cấu hình hiệu ứng icon -->
                    <li nz-submenu [nzTitle]="'hieu_ung_cho_bieu_tuong_chuyen_anh'| translate" [(nzOpen)]="openMapSub.submenu2" (nzOpenChange)="openHandler('submenu2', true)">
                      <!-- Bật/Tắt Hiệu ứng icon -->
                      <div class="config-name">
                        <p>{{'hieu_ung_bieu_tuong' | translate}}</p>
                        <nz-switch [(ngModel)]="config['main_image']['is_active_arrow_action']" (ngModelChange)="updateConfig()"></nz-switch>
                      </div>
                      <!-- Nếu có bật Hiệu ứng chuyển ảnh và Hiệu ứng icon -->
                      <div *ngIf="
                          config['main_image']['is_active_carousel'] &&
                          config['main_image']['is_active_arrow_action']" 
                          class="mt-3">
                        <!-- Cấu hình Hiệu ứng icon -->
                        <div *ngIf="config['main_image']['is_active_arrow_action']">
                          <!-- Thời gian chuyển hiệu ứng -->
                          <div class="config-name ">
                            <p>{{'thoi_gian_chuyen_hieu_ung' | translate}}</p>
                            <nz-input-number [nzMin]="0" [nzMax]="5" [nzStep]="0.1" 
                              [(ngModel)]="config['main_image']['arrow_action_hover_duration']" 
                              (ngModelChange)="updateConfig()">
                            </nz-input-number>
                          </div>
                          <!-- Màu biểu tượng -->
                          <div class="config-name">
                            <p>{{'mau_sac' | translate}}</p>
                            <input class="input-color" type="button"
                              [cpOKButton]="true" 
                              [style.background]="config['main_image']['arrow_action_hover_color']"
                              [(colorPicker)]="config['main_image']['arrow_action_hover_color']"
                              (colorPickerClose)="updateConfig()" />
                          </div>
                          <!-- Màu nền -->
                          <div class="config-name">
                            <p>{{'mau_nen' | translate}}</p>
                            <input class="input-color" type="button"
                              [cpOKButton]="true" 
                              [style.background]="config['main_image']['arrow_action_hover_background']"
                              [(colorPicker)]="config['main_image']['arrow_action_hover_background']"
                              (colorPickerClose)="updateConfig()"/>
                          </div>
                          <!-- Độ trong suốt -->
                          <div>
                            <div class="config-name">
                              <p>{{'do_trong_suot_bieu_tuong' | translate}}</p>
                              <nz-input-number [nzMin]="0" [nzMax]="1" [nzStep]="0.1"
                                [(ngModel)]="config['main_image']['arrow_action_hover_color_opacity']"
                                (nzBlur)="updateConfig()">
                              </nz-input-number>
                            </div>
                            <nz-slider [nzMin]="0" [nzMax]="1" [nzStep]="0.1"
                              [(ngModel)]="config['main_image']['arrow_action_hover_color_opacity']"
                              (nzOnAfterChange)="updateConfig()">
                            </nz-slider>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
            <!-- CÀI ĐẶT HÌNH ẢNH -->
            <li nz-submenu [nzTitle]="'cai_dat_hinh_anh' | translate" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
              <atw-image-detail-config-image 
                [objectChoosing]="objectChoosing" 
                [staticdata]="staticdata"
                [config]="config" 
                [class]="class" 
                [device]="device"
                (openViewDetail)="openViewAll(style_fields[4])">
              </atw-image-detail-config-image>
            </li>
            <!-- HIỆU ỨNG -->
            <li nz-submenu [nzTitle]="'hieu_ung' | translate" [(nzOpen)]="openMap.menu14" (nzOpenChange)="openHandler('menu14')">
              <app-choose-animations-config [type]="type" [elementChoosing]="objectChoosing" (openAnimationDetail)="openAnimationDetail($event)"
                [id_object]="objectChoosing._id" [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
                [cursorClass]="class['image-img']" [cursorClass2]="class['orther-image']"
                [titleCursor]="{ cursor1: 'con_tro_cua_anh_lon', cursor2: 'con_tro_cua_danh_sach_anh_nho' }"
                [conditionShowSelectEffect]="!config?.main_image?.is_active_image_zoom"
                [effect_hover]="effect_hover" [customize]="customize" [type]="'object'" [effectFileUsing]="'image-detail'">
              </app-choose-animations-config>
            </li>
            <!-- LIÊN KẾT -->
            <li nz-submenu [nzTitle]="'lien_ket' | translate" [(nzOpen)]="openMap.menu12" (nzOpenChange)="openHandler('menu12')">
              <app-link-page-config [type_page]="['detail_product']" [staticdata]="staticdata" [id_object]="objectChoosing._id">
              </app-link-page-config>
            </li>
          </ul>
        </li>
        <!-- CẤU HÌNH NHÓM ẢNH NHỎ -->
        <li nz-submenu [nzTitle]="'danh_sach_anh_khac' | translate" nzIcon="profile" *ngIf="gridObjSelected == 'side-image'">
          <ul nz-menu nzMode="inline">
            <!-- THAY ĐỔI VỊ TRÍ NHÓM ẢNH -->
            <li *ngIf="config['classes_image']['grid_class'] != 'image-detail-grid-3'" 
              nz-submenu [nzTitle]="'thay_doi_vi_tri_nhom_anh' | translate" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
              <!-- Vị trí nhóm ảnh Loại 1 và 2 -->
              <ng-container *ngIf="config['classes_image']['grid_class'] == 'image-detail-grid-0' || config['classes_image']['grid_class'] == 'image-detail-grid-1'">
                <nz-radio-group [(ngModel)]="config['side_image']['justify']" 
                  (ngModelChange)="updateConfig()"
                  class="radio-group">
                  <label nz-radio-button nzValue="flex-start" class="radio-button">{{'tren' | translate}}</label>
                  <label nz-radio-button nzValue="flex-end" class="radio-button">{{'duoi' | translate}}</label>
                  <label nz-radio-button nzValue="center" class="radio-button">{{'giua' | translate}}</label>
                  <label nz-radio-button nzValue="space-between" class="radio-button">{{'can_deu' | translate}}</label>
                </nz-radio-group>
              </ng-container>
              <!-- Vị trí nhóm ảnh Loại 3 -->
              <ng-container *ngIf="config['classes_image']['grid_class'] == 'image-detail-grid-2'">
                <nz-radio-group [(ngModel)]="config['side_image']['justify']" 
                  (ngModelChange)="updateConfig()"
                  class="radio-group">
                  <label nz-radio-button nzValue="flex-start" class="radio-button">{{'trai' | translate}}</label>
                  <label nz-radio-button nzValue="flex-end" class="radio-button">{{'phai' | translate}}</label>
                  <label nz-radio-button nzValue="center" class="radio-button">{{'giua' | translate}}</label>
                  <label nz-radio-button nzValue="space-between" class="radio-button">{{'can_deu' | translate}}</label>
                </nz-radio-group>
              </ng-container>
            </li>
            <!-- ĐƯỜNG VIỀN NHÓM ẢNH NHỎ -->
            <li nz-submenu [nzTitle]="'duong_vien_nhom_anh_nho' | translate" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
              <app-borders-config 
                [id_object]="objectChoosing._id"
                [device]="device"  [elementChoosing]="objectChoosing"
                [class]="class" 
                [borderClass]="class['orther-image']">
              </app-borders-config>
              <!-- Nút mở rộng -->
              <div class="config-name view-more-btn">
                <p (click)="openViewAll(style_fields[0])">{{'mo_rong' | translate}} &#8594;</p>
              </div>
            </li>
            <!-- ĐƯỜNG VIỀN KHUNG KHI CHỌN -->
            <li nz-submenu [nzTitle]="'duong_vien_khung_khi_duoc_chon' | translate" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
              <div class="editor-field"
                style=" display: flex; flex-wrap: wrap; justify-content: space-between; align-items: center;">
                <p class="m-0 item-border">Kiểu viền</p>
                <div class="field-widget">
                  <button nz-dropdown nzTrigger="click" [nzDropdownMenu]="menuBorder1" nzPopoverTrigger="click">
                    <mat-icon>border_style</mat-icon>
                  </button>
                </div>
                <!-- Menu các kiểu viền khác -->
                <nz-dropdown-menu #menuBorder1="nzDropdownMenu">
                  <ul nz-menu>
                    <!-- Kiểu viền solid -->
                    <li nz-menu-item>
                      <button (click)="config['image_actived']['outline_style']  = 'solid'; updateConfig()" nz-tooltip
                        nzTooltipTitle="Solid" nzTooltipPlacement="left" class="widget-button"
                        [ngClass]="{'active': config['image_actived']['outline_style']  == 'solid'}">
                        <div class="icon-field">
                          <svg width="16px" height="16px" viewBox="0 0 15 15" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M1.25 7.5C1.25 7.22386 1.47386 7 1.75 7H13.25C13.5261 7 13.75 7.22386 13.75 7.5C13.75 7.77614 13.5261 8 13.25 8H1.75C1.47386 8 1.25 7.77614 1.25 7.5Z"
                              fill="#000000" />
                          </svg>
                        </div>
                      </button>
                    </li>
                    <!-- Kiểu viền double -->
                    <li nz-menu-item>
                      <button (click)="config['image_actived']['outline_style']  = 'double'; updateConfig()" nz-tooltip
                        nzTooltipTitle="Double" nzTooltipPlacement="left" class="widget-button"
                        [ngClass]="{'active': config['image_actived']['outline_style']  == 'double'}">
                        <div class="icon-field">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                            class="bi bi-border-style" viewBox="0 0 16 16">
                            <path
                              d="M1 3.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-1zm0 4a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1zm0 4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm8 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-4 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm8 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-4-4a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1z" />
                          </svg>
                        </div>
                      </button>
                    </li>
                    <!-- Kiểu viền dashed -->
                    <li nz-menu-item>
                      <button (click)="config['image_actived']['outline_style']  = 'dashed'; updateConfig()" nz-tooltip
                        nzTooltipTitle="Dashed" nzTooltipPlacement="left" class="widget-button"
                        [ngClass]="{'active': config['image_actived']['outline_style']  == 'dashed'}">
                        <div class="icon-field">
                          <svg width="16px" height="16px" viewBox="0 0 15 15" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M0 7.5C0 7.22386 0.223858 7 0.5 7H3C3.27614 7 3.5 7.22386 3.5 7.5C3.5 7.77614 3.27614 8 3 8H0.5C0.223858 8 0 7.77614 0 7.5ZM5.75 7.5C5.75 7.22386 5.97386 7 6.25 7H8.75C9.02614 7 9.25 7.22386 9.25 7.5C9.25 7.77614 9.02614 8 8.75 8H6.25C5.97386 8 5.75 7.77614 5.75 7.5ZM12 7C11.7239 7 11.5 7.22386 11.5 7.5C11.5 7.77614 11.7239 8 12 8H14.5C14.7761 8 15 7.77614 15 7.5C15 7.22386 14.7761 7 14.5 7H12Z"
                              fill="#000000" />
                          </svg>
                        </div>
                      </button>
                    </li>
                    <!-- Kiểu viền dotted -->
                    <li nz-menu-item>
                      <button (click)="config['image_actived']['outline_style']  = 'dotted'; updateConfig()" nz-tooltip
                        nzTooltipTitle="Dotted" nzTooltipPlacement="left" class="widget-button"
                        [ngClass]="{'active': config['image_actived']['outline_style']  == 'dotted'}">
                        <div class="icon-field">
                          <i class="bi bi-three-dots"></i>
                        </div>
                      </button>
                    </li>
                  </ul>
                </nz-dropdown-menu>
              </div>
              <div class="item-border-size">
                <!-- Điều chỉnh kích thước viền trên -->
                <div class="config-name mb-0">
                  <p>{{'kich_thuoc' | translate}}</p>
                  <nz-input-number [nzMin]="0" [nzMax]="10"
                    [ngModel]="config['image_actived']['outline_width'] | vhnumber"
                    (ngModelChange)="config['image_actived']['outline_width'] = $event +'px'" (nzBlur)="updateConfig()">
                  </nz-input-number>
                </div>
                <nz-row>
                  <nz-col nzSpan="24">
                    <nz-slider [nzMin]="0" [nzMax]="10" [ngModel]="config['image_actived']['outline_width'] | vhnumber"
                      (ngModelChange)="config['image_actived']['outline_width'] = $event +'px'"
                      (nzOnAfterChange)="updateConfig()">
                    </nz-slider>
                  </nz-col>
                </nz-row>
              </div>
              <!-- Lựa chọn màu viền -->
              <div class="config-name">
                <p>{{'mau_vien' | translate}} </p>
                <input class="input-color" type="button" [style.background]="config['image_actived']['outline_color']"
                  [cpOKButton]="true" [(colorPicker)]="config['image_actived']['outline_color']" (colorPickerClose)="updateConfig()" />
              </div>
              <!-- Nút mở rộng -->
              <!-- <div class="config-name view-more-btn">
                  <p (click)="openViewAll(style_fields[0])">{{'mo_rong' | translate}} &#8594;</p>
                </div> -->
            </li>
            <!-- KÍCH THƯỚC NHÓM ẢNH -->
            <li nz-submenu [nzTitle]="'kich_thuoc_nhom_anh' | translate" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
              <div class="editor-field">
                <!-- width >=630 and < 837 -->
                <!-- Kích thước nhóm ảnh KHÔNG phải kiểu 3 -->
                <div *ngIf="config['classes_image']['grid_class'] != 'image-detail-grid-2'">
                  <div class="config-name">
                    <p>{{'kich_thuoc' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="1"
                      [ngModel]="config['orther_image']['width'] | vhnumber"
                      (ngModelChange)="config['orther_image']['width'] = $event +'px'"
                      (nzBlur)="updateConfig()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"
                    [ngModel]="config['orther_image']['width'] | vhnumber"
                    (ngModelChange)="config['orther_image']['width'] = $event +'px'"
                    (nzOnAfterChange)="updateConfig()">
                  </nz-slider>
                </div>
                <!-- Kích thước nhóm ảnh kiểu 3 -->
                <div *ngIf="config['classes_image']['grid_class'] == 'image-detail-grid-2'">
                  <div class="config-name">
                    <p>{{'kich_thuoc' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="1"
                      [ngModel]="config['orther_image_grid_2']['width'] | vhnumber"
                      (ngModelChange)="config['orther_image_grid_2']['width'] = $event +'%'"
                      (nzBlur)="updateConfig()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"
                    [ngModel]="config['orther_image_grid_2']['width'] | vhnumber"
                    (ngModelChange)="config['orther_image_grid_2']['width'] = $event +'%'"
                    (nzOnAfterChange)="updateConfig()">
                  </nz-slider>
                </div>
              </div>
            </li>
            <!-- KHOẢNG ĐỆM NHÓM ẢNH -->
            <li nz-submenu [nzTitle]="'khoang_dem_nhom_anh' | translate" [(nzOpen)]="openMap.menu11" (nzOpenChange)="openHandler('menu11')">
              <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                [classPadding]="class['orther-image__list']" [paddingConfigs]="[
                  { type: 'top' },
                  { type: 'bottom' },
                  { type: 'left' },
                  { type: 'right' }
                ]">
              </app-padding-config>
            </li>
            <!-- ICON CHUYỂN ẢNH -->
            <li nz-submenu [nzTitle]="'icon_chuyen_anh' | translate" [(nzOpen)]="openMap.menu7" (nzOpenChange)="openHandler('menu7')">
              <!-- Cấu hình icon -->
              <div class="field-row mb-3">
                <div class="mt-3">
                  <!-- Hiện icon khi di chuột -->
                  <div class="field-row mb-3">
                    <div class="config-name mt-0">
                      <p>{{'hien_icon_khi_di_chuot' | translate}}</p>
                      <nz-switch [(ngModel)]="config['orther_image']['is_hide_arrow']" (ngModelChange)="updateConfig()"></nz-switch>
                    </div>
                  </div>
                  <!-- Kiểu icon -->
                  <div class="field-row my-3">
                    <div class="config-name mt-0">
                      <p>{{'kieu' | translate}}</p>
                      <!-- KHÔNG PHẢI KIỂU 3 | Danh sách icon để chọn -->
                      <div *ngIf="config['classes_image']['grid_class'] != 'image-detail-grid-2'" style="width: 40%">
                        <!-- Nút chọn icon -->
                        <button nz-button nz-dropdown [nzDropdownMenu]="menu" style="width: 100%; padding: 2px;" [nzPlacement]="positionSelect">
                          <div style="font-size: 17px; display: flex; justify-content: space-around;">
                            <i [class]="config['orther_image']['arrow_up_icon']"></i>
                            <i [class]="config['orther_image']['arrow_down_icon']"></i>
                          </div>
                        </button>
                        <!-- Danh sách icon -->
                        <nz-dropdown-menu #menu="nzDropdownMenu">
                          <ul nz-menu>
                            <li nz-menu-item *ngFor="let item of bootstrapIconArrows"
                              (click)="onChangeArrowsUpDown(item)">
                              <div style="font-size: 18px; display: flex; justify-content: space-around; padding: 10px 0px;">
                                <i [class]="item.icon_up"></i>
                                <i [class]="item.icon_down"></i>
                              </div>
                            </li>
                          </ul>
                        </nz-dropdown-menu>
                      </div>
                      <!-- KIỂU 3 | Danh sách icon để chọn -->
                      <div *ngIf="config['classes_image']['grid_class'] == 'image-detail-grid-2'" style="width: 40%">
                        <!-- Nút chọn icon -->
                        <button nz-button nz-dropdown [nzDropdownMenu]="menu" style="width: 100%; padding: 2px;" [nzPlacement]="positionSelect">
                          <div style="font-size: 17px; display: flex; justify-content: space-around;">
                            <i [class]="config['orther_image']['arrow_left_icon']"></i>
                            <i [class]="config['orther_image']['arrow_right_icon']"></i>
                          </div>
                        </button>
                        <!-- Danh sách icon -->
                        <nz-dropdown-menu #menu="nzDropdownMenu">
                          <ul nz-menu>
                            <li nz-menu-item *ngFor="let item of bootstrapIconArrows"
                              (click)="onChangeArrowsGrid2(item)">
                              <div style="font-size: 18px; display: flex; justify-content: space-around; padding: 10px 0px;">
                                <i [class]="item.icon_left"></i>
                                <i [class]="item.icon_down"></i>
                              </div>
                            </li>
                          </ul>
                        </nz-dropdown-menu>
                      </div>
                    </div>
                  </div>
                  <!-- Kích thước icon -->
                  <div class="config-name my-3">
                    <p>{{'kich_thuoc' | translate}}</p>
                    <nz-input-number [nzMin]="1" [nzMax]="50" [nzStep]="1"
                      [(ngModel)]="config['orther_image']['arrow_size']" 
                      (nzBlur)="updateConfig()">
                    </nz-input-number>
                  </div>
                  <!-- Màu sắc icon -->
                  <div class="config-name">
                    <p>{{'mau_sac' | translate}}</p>
                    <input class="input-color" type="button"
                      [cpOKButton]="true" 
                      [style.background]="config['orther_image']['arrow_color']"
                      [(colorPicker)]="config['orther_image']['arrow_color']" 
                      (colorPickerClose)="updateConfig()" />
                  </div>
                  <!-- Màu nền -->
                  <div class="config-name">
                    <p>{{'mau_nen' | translate}}</p>
                    <input class="input-color" type="button"
                      [cpOKButton]="true" 
                      [style.background]="config['orther_image']['arrow_background']"
                      [(colorPicker)]="config['orther_image']['arrow_background']"
                      (colorPickerClose)="updateConfig()" />
                  </div>
                  <!-- Độ trong suốt -->
                  <div>
                    <div class="config-name">
                      <p>{{'do_trong_suot' | translate}}</p>
                      <nz-input-number [nzMin]="0" [nzMax]="1" [nzStep]="0.1"
                        [(ngModel)]="config['orther_image']['arrow_color_opacity']"
                        (nzBlur)="updateConfig()">
                      </nz-input-number>
                    </div>
                    <nz-slider [nzMin]="0" [nzMax]="1" [nzStep]="0.1"
                      [(ngModel)]="config['orther_image']['arrow_color_opacity']"
                      (nzOnAfterChange)="updateConfig()">
                    </nz-slider>
                  </div>
                  <!-- Nút mở rộng -->
                  <div class="config-name view-more-btn">
                    <p (click)="openViewAll(style_fields[3])">{{'mo_rong' | translate}} &#8594;</p>
                  </div>
                </div>
              </div>
            </li>
            <!--Cấu hình hiệu ứng icon -->
            <li nz-submenu [nzTitle]="'hieu_ung_cho_icon_chuyen_anh'| translate" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
              <!-- Bật/Tắt Hiệu ứng icon -->
              <div class="config-name">
                <p>{{'hieu_ung_bieu_tuong' | translate}}</p>
                <nz-switch [(ngModel)]="config['orther_image']['is_arrow_action']" (ngModelChange)="updateConfig()"></nz-switch>
              </div>
              <!-- Nếu có bật Hiệu ứng chuyển ảnh và Hiệu ứng icon -->
              <div *ngIf="config?.['orther_image']?.['is_arrow_action']" class="mt-3">
                <!-- Thời gian chuyển hiệu ứng -->
                <div class="config-name ">
                  <p>{{'thoi_gian_chuyen_hieu_ung' | translate}}</p>
                  <nz-input-number [nzMin]="0" [nzMax]="5" [nzStep]="0.1" 
                    [(ngModel)]="config['orther_image']['arrow_action_hover_duration']" 
                    (ngModelChange)="updateConfig()">
                  </nz-input-number>
                </div>
                <!-- Màu biểu tượng -->
                <div class="config-name">
                  <p>{{'mau_sac' | translate}}</p>
                  <input class="input-color" type="button"
                    [cpOKButton]="true" 
                    [style.background]="config['orther_image']['arrow_action_hover_color']"
                    [(colorPicker)]="config['orther_image']['arrow_action_hover_color']"
                    (colorPickerClose)="updateConfig()" />
                </div>
                <!-- Màu nền -->
                <div class="config-name">
                  <p>{{'mau_nen' | translate}}</p>
                  <input class="input-color" type="button"
                    [cpOKButton]="true" 
                    [style.background]="config['orther_image']['arrow_action_hover_background']"
                    [(colorPicker)]="config['orther_image']['arrow_action_hover_background']"
                    (colorPickerClose)="updateConfig()"/>
                </div>
                <!-- Độ trong suốt -->
                <div>
                  <div class="config-name">
                    <p>{{'do_trong_suot_bieu_tuong' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="1" [nzStep]="0.1"
                      [(ngModel)]="config['orther_image']['arrow_action_hover_color_opacity']"
                      (nzBlur)="updateConfig()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="1" [nzStep]="0.1"
                    [(ngModel)]="config['orther_image']['arrow_action_hover_color_opacity']"
                    (nzOnAfterChange)="updateConfig()">
                  </nz-slider>
                </div>
              </div>
            </li>
            <!-- SỐ LƯỢNG ẢNH HIỂN THỊ -->
            <li nz-submenu [nzTitle]="'so_luong_anh_hien_thi' | translate" [(nzOpen)]="openMap.menu8" (nzOpenChange)="openHandler('menu8')">
              <div class="editor-field">
                <div class="config-name mt-0">
                  <p>{{'so_luong' | translate}}</p>
                  <nz-input-number [nzMin]="0" [nzMax]="8" [nzStep]="1"
                    [(ngModel)]="config['orther_image']['total_image_show']"
                    (nzBlur)="updateConfig()">
                  </nz-input-number>
                </div>
                <nz-slider [nzMin]="0" [nzMax]="8" [nzStep]="1"
                  [(ngModel)]="config['orther_image']['total_image_show']"
                  (nzOnAfterChange)="updateConfig()">
                </nz-slider>
              </div>
            </li>
            <!-- ĐỘ BAO PHỦ -->
            <li nz-submenu [nzTitle]="'do_bao_phu' | translate" [(nzOpen)]="openMap.menu9" (nzOpenChange)="openHandler('menu9')">
              <app-object-fit-config 
                [device]="device" 
                [class]="class" 
                [style_field]="style_fields[1]"
                [objectFitClass]="class['orther-image']" 
                (isViewAll)="isOpenViewAll($event)"
                [objectChoosing]="objectChoosing">
              </app-object-fit-config>
            </li>
            <!-- VỊ TRÍ HÌNH ẢNH -->
            <li nz-submenu [nzTitle]="'vi_tri_hinh_anh' | translate" [(nzOpen)]="openMap.menu10" (nzOpenChange)="openHandler('menu10')">
              <div class="editor-field">  
                <!-- Ngang -->
                <div>
                  <div class="config-name mt-0">
                    <p>{{'ngang' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="1" 
                      [(ngModel)]="config['object_fit_ortherimage']['object_x']" 
                      (nzBlur)="handleSetPositionImage()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"  
                    [(ngModel)]="config['object_fit_ortherimage']['object_x']"
                    (ngModelChange)="config['object_fit_ortherimage']['object_x'] = $event"
                    (nzOnAfterChange)="handleSetPositionImage()">
                  </nz-slider>
                </div>
                <!-- Dọc -->
                <div class="my-3">
                  <div class="config-name">
                    <p>{{'doc' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="1" 
                      [(ngModel)]="config['object_fit_ortherimage']['object_y']"
                      (nzBlur)="handleSetPositionImage()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"
                    [(ngModel)]="config['object_fit_ortherimage']['object_y']"
                    (ngModelChange)="config['object_fit_ortherimage']['object_y'] = $event"
                    (nzOnAfterChange)="handleSetPositionImage()">
                  </nz-slider>
                </div>
              </div>
            </li>
            <!-- VIDEO YOUTUBE -->
            <li nz-submenu [nzTitle]="'Video youtube'" [(nzOpen)]="openMap.menu16" (nzOpenChange)="openHandler('menu16')">
              <h2>{{ 'nen_bieu_tuong' | translate }}</h2>
              <!-- Màu nền -->
              <div class="config-name mt-2">
                <p>{{'mau_nen' | translate}}</p>
                <input class="input-color" type="button"
                  [cpOKButton]="true" 
                  [style.background]="class['sm-image__icon-video--wrapper']['background-color']"
                  [(colorPicker)]="class['sm-image__icon-video--wrapper']['background-color']"
                  (colorPickerClose)="updateClass()"/>
              </div>
              <!-- Chiều rộng -->
              <div class="mt-2">
                <div class="config-name mt-0">
                  <p>{{'chieu_rong' | translate}}</p>
                  <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="1" 
                    [(ngModel)]="class['sm-image__icon-video--wrapper']['width']" 
                    (ngModelChange)="class['sm-image__icon-video--wrapper']['width'] = $event + 'px'"
                    (nzBlur)="updateClass()">
                  </nz-input-number>
                </div>
                <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"  
                  [(ngModel)]="class['sm-image__icon-video--wrapper']['width']"
                  (ngModelChange)="class['sm-image__icon-video--wrapper']['width'] = $event + 'px'"
                  (nzOnAfterChange)="updateClass()">
                </nz-slider>
              </div>
              <!-- Chiều cao -->
              <div class="mt-2">
                <div class="config-name">
                  <p>{{'chieu_cao' | translate}}</p>
                  <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="1" 
                    [(ngModel)]="class['sm-image__icon-video--wrapper']['height']"
                    (ngModelChange)="class['sm-image__icon-video--wrapper']['height'] = $event + 'px'"
                    (nzBlur)="updateClass()">
                  </nz-input-number>
                </div>
                <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"
                  [(ngModel)]="class['sm-image__icon-video--wrapper']['height']"
                  (ngModelChange)="class['sm-image__icon-video--wrapper']['height'] = $event + 'px'"
                  (nzOnAfterChange)="updateClass()">
                </nz-slider>
              </div>
              <div>
                <li nz-submenu [nzTitle]="'vien' | translate">
                  <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                    [borderClass]="class['sm-image__icon-video--wrapper']" [id_object]="objectChoosing._id">
                  </app-borders-config>
                </li>
                <li nz-submenu [nzTitle]="'bo_goc' | translate">
                  <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                    [borderRadiusClass]="class['sm-image__icon-video--wrapper']" [id_object]="objectChoosing._id">
                  </app-borders-radius-config>
                </li>
              </div>
              <hr />
              <h2>{{ 'bieu_tuong' | translate }}</h2>
              <!-- Thay đỏi biểu tượng -->
              <div class="d-flex justify-content-between mx-1">
                <mat-icon>{{ config.video_youtube?.icon || 'play_arrow' }}</mat-icon>
                <button nz-button nzType="default" (click)="openDialogChooseIcon()" style="border-radius: 5px">
                  {{'thay_doi' | translate}}
                </button>
              </div>
              <!-- Màu biểu tượng -->
              <div class="config-name">
                <p>{{'mau_bieu_tuong' | translate}}</p>
                <input class="input-color" type="button"
                  [cpOKButton]="true" 
                  [style.background]="class['sm-image__icon-video']['color']"
                  [(colorPicker)]="class['sm-image__icon-video']['color']"
                  (colorPickerClose)="updateClass()" />
              </div>
              <!-- Kích thước biểu tượng -->
              <div class="mt-2">
                <div class="config-name">
                  <p>{{'kich_thuoc_bieu_tuong' | translate}}</p>
                  <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="1" 
                    [(ngModel)]="class['sm-image__icon-video']['font-size']"
                    (ngModelChange)="class['sm-image__icon-video']['font-size'] = $event + 'px'"
                    (nzBlur)="updateClass()">
                  </nz-input-number>
                </div>
                <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"
                  [(ngModel)]="class['sm-image__icon-video']['font-size']"
                  (ngModelChange)="class['sm-image__icon-video']['font-size'] = $event + 'px'"
                  (nzOnAfterChange)="updateClass()">
                </nz-slider>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>

  <!-- PHẦN MỞ RỘNG -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết viền của phần tử trong frame -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config 
        [device]="device" 
        [class]="class" 
        [borderRadiusClass]="class['orther-image']"
        [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>

    <!-- Cấu hình chi tiết viền của icon ảnh chính -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 3">
      <app-borders-radius-config
        [id_object]="objectChoosing._id"
        [device]="device" 
        [class]="class" 
        [borderRadiusClass]="class['main-image__icon']">
      </app-borders-radius-config>
    </div>

    <!-- Cấu hình chi tiết viền của icon của nhóm ảnh nhỏ -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 4">
      <app-borders-radius-config 
        [id_object]="objectChoosing._id"
        [device]="device" 
        [class]="class" 
        [borderRadiusClass]="config['border_orther_image']">
      </app-borders-radius-config>
    </div>
    
    <!-- Từ image-detail-config-image truyền về -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 5">
      <app-borders-radius-config 
        [id_object]="objectChoosing._id"
        [device]="device" 
        [class]="class" 
        [borderRadiusClass]="class['image-img']">
      </app-borders-radius-config>
    </div>

    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="config['animation-selected'].id != '000000'  && currentViewAll.index == 6">
      <app-animations-config [type]="type" [elementChoosing]="objectChoosing" [device]="device" [staticdata]="staticdata" [id_object]="objectChoosing._id"
       [customize]="customize"></app-animations-config>
   </div>
  </div>
</div>